import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  class: "filter-container",
  style: {"margin-top":"20px"}
}

import Pagination from '@/components/Pagination.vue'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import SelectChannel from '@/components/SelectChannel.vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'SaasOrderList',
  setup(__props) {

const route = useRoute()
    const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const filters = reactive({
            order_no:'',// 商品名称
            name:'',// 券码名称
            callbackflag:'',  //订单状态
            start_time:'',// 开始时间
            end_time:'',// 结束时间
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
            channel_no: store.state.user.userInfo.user_type !== 1 ? store.state.user.userInfo.channel_no || '' : '',  // 渠道号 
            export_type:0, // 导出
            user_type: store.state.user.userInfo.user_type || 0, // 用户类型
    })
    const tableData = ref([])
    const total = ref(0)
    const url = ref('')
    // 获取列表数据
    const getList = () => {
        if(filters.export_type === 1){
            let tmpParams = JSON.parse(JSON.stringify(filters));
            tmpParams.name = tmpParams.name ? encodeURIComponent(tmpParams.name) : '';
            window.open(`${Keys.baseUrl}/couponrecharge/coupon_api/channelOrderList?${joinParams(tmpParams)}`);
        }else{
            proxy.$http.get(url.value, filters).then(res => {
                const { code, data, msg } = res
                if (code != 200) { 
                    return proxy.$message({ type: 'error', message: msg }) }
                tableData.value = data.data
                total.value = data.total
            })
        }
    }
    const search = () => {
        filters.page = 1
        filters.export_type = 0
        getList()
    }
    const toExport = () => {
        filters.export_type = 1
        getList()
    }          
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        url.value = '/couponrecharge/coupon_api/channelOrderList'
        getList()
    })
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no : ''
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (filters.user_type == 1)
        ? (_openBlock(), _createBlock(SelectChannel, {
            key: 0,
            style: {"width":"250px"},
            modelValue: filters.channel_no,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.channel_no) = $event)),
            onChannelChange: onChannelChange
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单号",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券码名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.callbackflag,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.callbackflag) = $event)),
        placeholder: "订单状态",
        clearable: "",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "已完成",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "下单失败",
            value: "2"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_time) = $event)),
        placeholder: "开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_time) = $event)),
        placeholder: "结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (toExport()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        (filters.user_type == 1)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "channel_name",
              label: "渠道名称"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "券码名称",
          width: "170px"
        }),
        _createVNode(_component_el_table_column, {
          label: "券码信息",
          width: "260px"
        }, {
          default: _withCtx((scope) => [
            ( scope.row.coupon_info.length>=1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, "券码名称：" + _toDisplayString(scope.row.name), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", null, "有效期：" + _toDisplayString(scope.row.coupon_info[0].createTime) + "至" + _toDisplayString(scope.row.coupon_info[0].endTime), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "订单状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.callbackflag === 1 ? '已完成' : '下单失败'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "下单失败原因",
          width: "200px"
        }, {
          default: _withCtx((scope) => [
            ( scope.row.callbackflag == 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", null, _toDisplayString(scope.row.callbackmsg), 1),
                  _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "retailprice",
          label: "单价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "num",
          label: "数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "总金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price",
          label: "结算单价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "支付时间",
          width: "220px",
          fixed: "right"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})